module.exports = __webpack_public_path__ + "static/img/11.1c92933.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/sp/11.png
// module id = OeJ/
// module chunks = 0